<script>
    import { params } from '@sveltech/routify'
    import { onMount, onDestroy } from 'svelte'

    import Chatter from '../../components/Chatter.svelte'
    import IrcService from '../../helpers/IrcService'
    import { ircStore } from '../../stores/ircStore'
    import { chatStore } from '../../stores/chatStore'

    import ChatConfigService from '../../helpers/ChatConfigService.js'
    import AuthService from '../../helpers/AuthService'
    import FontHelper from '../../helpers/FontHelper.js'

    import { expoInOut } from 'svelte/easing'
    import { crossfade } from 'svelte/transition'
    import { flip } from 'svelte/animate'

    import anime from 'animejs/lib/anime.es.js'
    import { get } from 'svelte/store'
    anime.suspendWhenDocumentHidden = false

    let users = []
    let userBatches = []
    const MESSAGE_POLL_INTERVAL = 1000
    const BASE_SPEED = 15000
    let pollTimer
    let messageStyles = []

    const [send, receive] = crossfade({
        duration: (d) => Math.sqrt(d * 100),

        fallback(node, params) {
            const style = getComputedStyle(node)
            const transform = style.transform === 'none' ? '' : style.transform
            const height = style.height

            return {
                duration: 1000,
                easing: expoInOut,
                css: (t) => `
					opacity: ${t};
				`,
            }
        },
    })

    onMount(async () => {
        await AuthService.codeLogin($params.key, 'chat')
        await ChatConfigService.get()

        // poll the IRC store instead of subscribing
        pollTimer = setInterval(() => {
            const store = get(ircStore)
            const storeValues = Object.values(store)

            // remove old inactive chatters
            const filteredValues = storeValues.filter(
                (user) => user.getMessageRate() !== 0
            )

            // apply the css rules appropriate for their MPM
            filteredValues.forEach(
                (user) => (user.css = findBestStyles(user.getMessageRate()))
            )

            users = [...filteredValues]
        }, MESSAGE_POLL_INTERVAL)

        getNextUserBatch()
        startAnimationLoop()
    })

    const chatStoreUnsubscribe = chatStore.subscribe((res) => {
        messageStyles = [...res].sort(
            (a, b) => a.messagesPerMinute - b.messagesPerMinute
        )

        const fonts = FontHelper.mapFonts(messageStyles)
        FontHelper.loadFonts(fonts)
    })

    onDestroy(() => {
        clearInterval(pollTimer)
        chatStoreUnsubscribe()
    })

    function startAnimationLoop() {
        let animation = anime({
            targets: '.batch',
            translateY: (el) => {
                return -el.clientHeight * (userBatches.length + 1)
            },
            autoplay: true,
            duration: BASE_SPEED * userBatches.length,
            easing: 'linear',
            loopBegin: () => {
                // console.log('started')
            },
            loopComplete: () => {
                // console.log('completed')
                getNextUserBatch()
                // console.log('showing : ', userBatches.length)
                animation.seek(0)
                setTimeout(() => {
                    startAnimationLoop()
                }, 1000)
            },
        })
    }

    function getNextUserBatch() {
        var perChunk = 10 // items per chunk

        var result = users.reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index / perChunk)

            if (!resultArray[chunkIndex]) {
                resultArray[chunkIndex] = [] // start a new chunk
            }

            resultArray[chunkIndex].push(item)

            return resultArray
        }, [])
        userBatches = result
    }

    function findBestStyles(messagesPerMinute) {
        let bestMatchingConfig
        const nextIndex = messageStyles.findIndex((config) => {
            // find the first config that *doesnt* match our MPM
            return config.messagesPerMinute > messagesPerMinute
        })
        // we now use the one *before* so that we can do ranges of styles
        // if the user has created a rule for 1MPM and 10MPM, and we hit 5MPM
        // we need to use the rule for 1MPM. The same applies if they hit 20MPM we need to use the rule for 10

        // if we get a -1 it means it couldn't find a config big enough so use the biggest available
        // otherwise we use the *previous* matching config
        let index = nextIndex < 0 ? messageStyles.length - 1 : nextIndex - 1
        // use our new index to find a style, or just fall back to style 0 if we find nothing (shouldnt happen)
        bestMatchingConfig = messageStyles[index]
            ? messageStyles[index]
            : messageStyles[0]

        let {
            fontSize = 20,
            font = 'Open Sans',
            color = 'black',
        } = bestMatchingConfig

        return bestMatchingConfig
    }
</script>

<div class="h-screen w-screen overflow-hidden">
    <!-- this is an empty box so the batches start off screen -->
    <div class=" h-screen w-screen overflow-hidden" />

    {#each userBatches as batch, i}
        <div class="batch h-full w-full p-8">
            <div class="flex flex-grow h-full flex-col place-content-around">
                {#each batch as user (user.username)}
                    <div
                        class="origin-center {Math.round(Math.random()) ? 'text-left' : 'text-right'}"
                        in:receive|local={{ key: user.username }}
                        out:send|local={{ key: user.username }}
                        animate:flip>
                        <Chatter user={$ircStore[user.username]} />
                    </div>
                {/each}
            </div>
        </div>
    {/each}
</div>

<style>
</style>
